
<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
            <h4 slot="header" class="card-title d-md-flex justify-content-between align-items-center">
              <span>Üye Ara</span>
            </h4>
            <div class="filters my-3 d-flex flex-column align-items-center position-relatice">
              <div class="user-types">
                Arama
              </div>
              <div class="input-group w-25">
                <input type="text" class="form-control border-primary text-primary" v-on:keyup="getPosts()" v-model="query" placeholder="Ne aramıştınız?">
                <div class="input-group-append">
                  <span class="input-group-text bg-white border-primary text-primary" id="basic-addon2"><i class="fas fa-circle-notch fa-spin d-none" id="small-spinner"></i></span>
                </div>
              </div>
              
              
            </div>
            <table class="table table-hover table-striped table-bordered mb-0">
              <thead class="thead-dark">
                <th>E-Posta</th>
                <th>İsim</th>
                <th>Telefon Numarası</th>
                <th>Kullanıcı Adı</th>
                <th>İşlemler</th>
              </thead>
              <tbody>
                <tr v-for="item in table" :key="item.id">
                  <td>{{item.email}}</td>
                  <td>{{item.name}} {{item.surname}}</td>
                  <td>{{item.username}}</td>
                  <td>{{item.phone}}</td>
                  <td style="width:15%">
                    <a href="javascript:void(0)" class="btn btn-xs btn-danger btn-fill" v-if="item.is_active" v-on:click="deactivate(item.id)" v-b-tooltip title="Pasif Et" id="deactivate-item.id"><i class="fas fa-unlink"></i></a>
                    <a href="javascript:void(0)" class="btn btn-xs btn-success btn-fill" v-if="!item.is_active" v-b-tooltip v-on:click="activate(item.id)" title="Aktif Et" id="activate-item.id"><i class="fas fa-link"></i></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </card>
        </div>
      </div>
    </div>
  </div>
  
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'

  export default {
    data: function () {
      return {
        user:{
          is_active:0
        },
        table: null,
        total: 0,
        limit: localStorage.getItem('filterLimit'),
        page: 1,
        pageCount: null,
        navigation: true,
        type: 'all',
        query:null,
        tmId:null,
        viewCounts: []
      }
    },
    components: {
      Card
    },

    methods: {
      deactivate: function(id){
        this.toggleLoader()
        this.user.is_active = 0
        this.$http.post('/api/users/edit/' + id, this.user).then(
          response => {
            this.notifier('top', 'right', 'warning', 'Üye Pasif Edildi')
            this.getPosts(this.page,this.type)
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      activate: function(id){
        this.toggleLoader()
        this.user.is_active = 1
        this.$http.post('/api/users/edit/' + id, this.user).then(
          response => {
            this.notifier('top', 'right', 'success', 'Üye Aktif Edildi')
            this.getPosts(this.page,this.type)
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      isActive: function (v) {
        return v === this.page
      },
      isFirst: function () {
        return this.page === 1
      },
      isLast: function () {
        return this.page === Math.ceil(this.total / this.limit)
      },
      getPosts: function () {

        if(this.tmId){
          clearTimeout(this.tmId);
        }
        this.tmId = setTimeout(()=>{
          if(this.query){
            document.getElementById('small-spinner').classList.remove('d-none');
            this.$http.get('/api/search-user/' + this.query)
            .then(
              response => {
                document.getElementById('small-spinner').classList.add('d-none');
                this.table = response.body
                clearTimeout(this.tmId);
              },
              er => {
                this.notifier(
                  'top',
                  'right',
                  'danger',
                  'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
                  )
                clearTimeout(this.tmId);
              })
          }
        },700)
      },
      toggleNavigation () {
        var button = event.target
        if (this.navigation) {
          button.innerHTML = '<i class="fas fa-caret-down"></i>'
          this.navigation = false
        } else {
          button.innerHTML = '<i class="fas fa-caret-up"></i>'
          this.navigation = true
        }
      },
      toggleNewPostPanel (event) {
        event.stopPropagation()
        if (document.getElementById('new-post').classList.contains('d-none')) {
          document.getElementById('new-post').classList.remove('d-none')
        } else {
          document.getElementById('new-post').classList.add('d-none')
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {

      })
    }
  }
</script>
<style>
.highlight { background-color: yellow }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MemberModules/Search.vue